import find from "lodash/find";
import {
  SeatSelectTypes,
  SeatsIOSeat,
} from "~components/reservation/constants";
import { addPropertiesToSeats } from "~features/seated-reservation/helpers/addPropertiesToSeats";
import { log } from "~features/seated-reservation/helpers/stateLogger";
import { getCategoryDataFromLabel } from "~features/seated-reservation/helpers/zoneFilters";
import { getState, setState, StoreState } from "../index";
import { ConvergeSdk } from "@seeka-labs/converge";

interface UserSelectedSeatsProps {
  seats: SeatsIOSeat[];
}

export const userSelectedSeats = async (
  payload: UserSelectedSeatsProps,
  converge?: ConvergeSdk
) => {
  log("userSelectedSeats", payload);

  const state = getState();

  const seats = addPropertiesToSeats({
    seats: payload.seats,
    multiBuyPromotions: state.multiBuyPromotions,
    eventTicketTypes: state.eventTicketTypes,
    releasedZones: state.releasedZones,
  });

  const categoryLabel = seats?.[0]?.category?.label;

  if (!categoryLabel || !state.selectableZones) {
    console.error("Can't select seat USER_SELECTED_SEATS");
    return;
  }

  const updates: Partial<StoreState> = {
    selectionType: "user",
  };

  const { zone: zoneLabel, section: sectionLabel } =
    getCategoryDataFromLabel(categoryLabel);

  const zone = find(state.selectableZones, { name: zoneLabel });

  if (zone) {
    updates.currentZone = zone;

    if (zone?.sections?.length > 0) {
      updates.currentSection = find(zone.sections, {
        name: sectionLabel,
      });
    }
  }

  const newSeats =
    state.options.seatSelectType === SeatSelectTypes.FREE_SELECT
      ? [...(state.seats && state.seats), ...seats]
      : seats;

  void converge?.track?.addToCart({
    productIdentifier: state.event.id,
    productName: state.event.title,
    unitPrice: newSeats[0].price, // Currently when you select seats, each seat is the same type so just use the data from the first one.
    variantIdentifier: newSeats[0].ticketType?.id,
    variantName: newSeats[0].ticketType?.name,
    quantity: newSeats.length,
  });

  setState({
    seats: newSeats,
    selectFailed: false,
    sidebarIndex: 3,
    availableTicketTypes:
      updates.currentSection?.sectionTicketTypes ||
      updates.currentSection?.ticketTypes ||
      updates.currentZone?.ticketTypes,
    ...updates,
  });
};
